import React from "react"
import {
    IPunchSetDocument,
    ITimecardDay,
    ITimecardEmployee
} from "../../models"
import autobind from "class-autobind"
import EmployeeTimecardTablePSCell from "./EmployeeTimecardTablePSCell"

interface IProps {
    childPunchSets: IPunchSetDocument[]
    timecardDay: ITimecardDay
    user: ITimecardEmployee
    fullPunchSets: IPunchSetDocument[]
    showTimecardDetails: boolean
}

interface IState {
}

export default class EmployeeTimecardTablePSCellChildrenList extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
        }
        autobind(this)
    }

    render() {
        return (
            <span>
                {this.props.childPunchSets.map((timecardPS, index) =>
                    <EmployeeTimecardTablePSCell
                        key={index}
                        day={this.props.timecardDay}
                        childPunchSets={null}
                        timecardLocked={false}
                        readonly={true}
                        punchSet={this.props.fullPunchSets.find(i => i.Id === timecardPS.Id)}
                        addPunch={null}
                        user={this.props.user}
                        onConfirmDelete={null}
                        onTimeChange={null}
                        reloadTimecard={null}
                        showTimecardDetails={this.props.showTimecardDetails} 
                        fullPunchSets={this.props.fullPunchSets}                    
                    />
                )}
            </span>
        )
    }
}
